import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "@/lib/i18n";
import { StoreProvider } from "@/lib/store";
import { AuthProvider, ProtectedRoute } from "@/lib/auth";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { ScrollManager } from "@/components/ScrollManager";
import Landing from "@/pages/Landing";
import OrderBuilder from "@/pages/OrderBuilder";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import PayPalReturn from "@/pages/PayPalReturn";
import TrackOrder from "@/pages/TrackOrder";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminOrderDetail from "@/pages/admin/AdminOrderDetail";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminGallery from "@/pages/admin/AdminGallery";

const PublicLayout = () => (
  <div className="flex min-h-screen flex-col">
    <ScrollManager />
    <SiteHeader />
    <main className="flex-1">
      <Outlet />
    </main>
    <SiteFooter />
  </div>
);

function App() {
  return (
    <LangProvider>
      <StoreProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Landing />} />
                <Route path="/order" element={<OrderBuilder />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/payment/paypal" element={<PayPalReturn />} />
                <Route path="/track" element={<TrackOrder />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<AdminOrders />} />
                <Route path="orders/:id" element={<AdminOrderDetail />} />
                <Route path="settings" element={<AdminSettings />} />
                <Route path="gallery" element={<AdminGallery />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" theme="dark" richColors />
        </AuthProvider>
      </StoreProvider>
    </LangProvider>
  );
}

export default App;
